import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/create-store';
import { IPageState, CommunityPagesByType } from 'store/pages/types';

const getBasePagesState = (state: RootState): IPageState => state.pages;

export const getPagesState = createSelector([getBasePagesState], pagesState => {
  let clientPages = pagesState?.data?.clientPages;
  let allPages = pagesState?.data?.allPages;

  if (clientPages?.pages) {
    clientPages = {
      ...clientPages,
      pages: clientPages.pages.map(page => ({
        ...page,
        donation_amounts: Array.isArray(page.donation_amounts)
          ? page.donation_amounts.map(amount => amount / 100)
          : page.donation_amounts,
      })),
    };
  }

  if (allPages?.pages) {
    allPages = {
      ...allPages,
      pages: allPages.pages.map(page => ({
        ...page,
        donation_amounts: Array.isArray(page.donation_amounts)
          ? page.donation_amounts.map(amount => amount / 100)
          : page.donation_amounts,
      })),
    };
  }

  return {
    ...pagesState,
    data: {
      ...pagesState.data,
      clientPages,
      allPages,
    },
  };
});

const emptyCommunityPages: CommunityPagesByType = {
  donate: [],
  event: [],
  recommendation: [],
};

export const getCommunityPagesForCommunity = createSelector(
  [getBasePagesState],
  (pagesState): { allPagesByType: CommunityPagesByType; allPagesLoading: boolean } => ({
    allPagesByType: pagesState?.data?.communityPagesByType ?? emptyCommunityPages,
    allPagesLoading: pagesState?.communityPagesLoading ?? false,
  })
);
